import React, { useEffect, useRef } from 'react';
/**
 * Base full-bleed style for the second-screen video; object-fit is applied per
 * instance from the {@code fit} prop.
 */
const VIDEO_STYLE = {
    background: '#000',
    height: '100%',
    width: '100%'
};
/**
 * Renders a meeting track into the second-screen window by cloning it and
 * wrapping the clone in that window's own {@code MediaStream}. This mirrors the
 * feature's original imperative {@code renderTrack}, but driven by React so the
 * clone is stopped automatically when the component unmounts or the track
 * changes. Cloning into the window's own {@code MediaStream} (rather than
 * attaching the meeting-realm stream directly) keeps the {@code srcObject} in the
 * same window realm as the {@code <video>}.
 *
 * @param {IProps} props - The component props.
 * @returns {ReactElement}
 */
const SecondScreenVideo = ({ fit = 'contain', track, win }) => {
    const videoRef = useRef(null);
    useEffect(() => {
        const video = videoRef.current;
        let clone;
        if (video) {
            clone = track.clone();
            video.srcObject = new win.MediaStream([clone]);
        }
        return () => {
            clone?.stop();
            if (video) {
                video.srcObject = null;
            }
        };
    }, [track, win]);
    return (React.createElement("video", { autoPlay: true, muted: true, playsInline: true, ref: videoRef, style: { ...VIDEO_STYLE, objectFit: fit } }));
};
export default SecondScreenVideo;
